import { Company } from '~/types/company';
import { Manufacturer } from '~/hooks/useStrategicMap';
import { EquipmentType } from '~/types/equipmentType';
import { SelectItem } from '~/types/selectItem';
import { Extension } from '~/types/extension';

// eslint-disable-next-line no-shadow
export enum IdadeParqueMaquinas {
  ATE_1_ANO,
  ANOS2 = 1,
  ANOS3 = 2,
  ANOS4 = 3,
  ANOS5 = 4,
  ACIMA_5_ANOS = 5,
}

export const idadePaqueLista = [
  { value: IdadeParqueMaquinas.ATE_1_ANO.toString(), label: 'Até 1 ano' },
  { value: IdadeParqueMaquinas.ANOS2.toString(), label: '2 anos' },
  { value: IdadeParqueMaquinas.ANOS3.toString(), label: '3 anos' },
  { value: IdadeParqueMaquinas.ANOS4.toString(), label: '4 anos' },
  { value: IdadeParqueMaquinas.ANOS5.toString(), label: '5 anos' },
  {
    value: IdadeParqueMaquinas.ACIMA_5_ANOS.toString(),
    label: 'Acima de 5 anos',
  },
];

// eslint-disable-next-line no-shadow
export enum TipoAquisicaoParqueMaquinas {
  LOCADO,
  ADQUIRIDO,
  LEASING,
}

export const tipoAquisicaoParqueMaquinasLista: SelectItem[] = [
  { value: TipoAquisicaoParqueMaquinas.LOCADO.toString(), label: 'Locado' },
  {
    value: TipoAquisicaoParqueMaquinas.ADQUIRIDO.toString(),
    label: 'Adquirido',
  },
  { value: TipoAquisicaoParqueMaquinas.LEASING.toString(), label: 'Leasing' },
];

export interface MachinePark {
  id?: number;
  empresa?: Company;
  fabricante?: Manufacturer;
  quantidade: number;
  idade?: string;
  tipo_equipamento: EquipmentType;
  descricao: string;
  tipo_aquisicao: string;
  fornecedor: string;
  status: number;
  dt_ultimaatualizacao: string;
  usuario: string;
}

export interface MachineParkView extends MachinePark {
  statusStr: string;
  statusColor: string;
  dataFormatada: string;
  aquisicaoFormatado: string;
  idadeFormatada: string;
}

export interface MachineParkCreate {
  id?: number;
  empresa?: number;
  fabricante?: number;
  quantidade: number;
  idade?: IdadeParqueMaquinas;
  tipo_equipamento: number;
  descricao: string;
  tipo_aquisicao: TipoAquisicaoParqueMaquinas;
  fornecedor?: string;
  grupo_economico: number;
}

export interface MachineParkContractDetail {
  id_contrato: string;
  nu_contrato: string;
  ds_rotaminutacontrato: string;
  dt_inicialcontrato: string;
  nu_mesescontrato: string;
  prazo_contrato: string;
  vr_totalinicialcontrato: string;
  vr_totalmensalcontrato: string;
  vr_mensal_atual: string;
  dd_ajusteinflacao: string;
  mm_ajusteinflacao: string;
  tp_consolidacaofatura: string;
  tp_situacao: string;
  dh_ultimaatualizacao: string;
  id_indicecorrecao: number;
  ds_observacao: string;
  dt_encerramentocontrato: string;
  mes_encerramentocontrato: string;
  nm_indicecorrecao: string;
  nu_pedido: string;
  vr_totalcontrato: string;
  status_pgto: string;
  vencimento_final?: string;
  vr_pago_ate_momento: string;
  vr_pendente_pagamento: string;
  qtd_extensoes: number;
  qtd_faturas_em_aberto: number;
  extensoes: Extension[];
}

export interface MachineParkContractDetailView
  extends MachineParkContractDetail {
  formattedMensalValue: string;
  formattedInitialDate: string;
  formattedEndDate: string;
  formattedMonth: string;
  colorScheme: string;
  status_pgto: string;
  formattedVrPagoAteMomento: string;
  formattedVrPendentePagamento: string;
}
